export default __webpack_public_path__ + "static/media/review-woman-1.46db3037.png";